<sl-input
    id="calendar"
    ngDefaultControl
    type="date"
    [name]="key"
    [label]="props.label | htmlDecode"
    [readonly]="props.readonly"
    [disabled]="props.disabled || false" 
    [required]="props.required || false"
    [formControl]="formControl" 
    [formlyAttributes]="field">

    <sl-icon slot="suffix" name="calendar3"></sl-icon>
</sl-input>